type Scope={gtag?:(...args:unknown[])=>void;dataLayer?:unknown[];smartyfindAnalyticsConsent?:boolean;wp_has_consent?:(category:string)=>boolean;PantofiNoiGDPRDebug?:{consent?:{analytics?:boolean}}};
export function assistantAnalyticsAllowed(scope:Scope):boolean {
  if(typeof scope.smartyfindAnalyticsConsent==='boolean')return scope.smartyfindAnalyticsConsent;
  if(typeof scope.PantofiNoiGDPRDebug?.consent?.analytics==='boolean')return scope.PantofiNoiGDPRDebug.consent.analytics;
  try{return scope.wp_has_consent?.('statistics')===true;}catch{return false;}
}
export function emitAssistantAnalytics(action:string,data:Record<string,unknown>={},scope:Scope=globalThis as Scope):boolean {
  if(!assistantAnalyticsAllowed(scope))return false;
  const actions=['open','close','message','results','product_click','add_to_cart','checkout','purchase_assist','compare','error','whatsapp_handoff','operator_handoff'];
  if(!actions.includes(action))return false;
  const payload:Record<string,unknown>={surface:'smartyfind_assistant'};
  for(const key of ['results_count','latency_ms','value'])if(typeof data[key]==='number'&&Number.isFinite(data[key]))payload[key]=data[key];
  if(typeof data.currency==='string'&&/^[A-Z]{3}$/.test(data.currency))payload.currency=data.currency;
  if(typeof data.status==='string'&&/^[a-z_]{1,30}$/.test(data.status))payload.status=data.status;
  const name=`sf_assistant_${action}`;
  if(typeof scope.gtag==='function'){scope.gtag('event',name,payload);return true;}
  if(Array.isArray(scope.dataLayer)){scope.dataLayer.push({event:name,...payload});return true;}
  return false;
}
